import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/AuthProvider';
import { api } from '@/lib/api';
import type { DraftsCount } from '@/lib/types';

export const DRAFTS_QUERY_KEY = ['me', 'drafts'] as const;

/** عددُ المسودات للزرّ (0119) — يُعاد كلَّ دقيقة ويُبطَل بعد كل حذف */
export function useDraftsCount(enabled = true) {
  const { institutionId } = useAuth();
  return useQuery({
    queryKey: [...DRAFTS_QUERY_KEY, 'count', institutionId],
    queryFn: () => api.get<DraftsCount>('/me/drafts/count'),
    enabled, refetchInterval: 60_000, staleTime: 30_000,
  });
}
